// WelcomeCard.jsx - Personalized welcome section
import React from 'react';
import { Card, Typography, Avatar, Button, Tag } from 'antd';
import { 
  UserOutlined, 
  CalendarOutlined, 
  TrophyOutlined,
  RocketOutlined 
} from '@ant-design/icons';

const { Title, Text } = Typography;

const WelcomeCard = ({ user }) => {
  const currentHour = new Date().getHours();
  const getGreeting = () => {
    if (currentHour < 12) return 'Good morning';
    if (currentHour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  const getMotivationalMessage = () => {
    const messages = [
      "Ready to create something amazing today?",
      "Your portfolio is looking fantastic!",
      "Time to showcase your brilliant work!",
      "Another day, another opportunity to shine!",
      "Let's build something incredible together!"
    ];
    return messages[Math.floor(Math.random() * messages.length)];
  };

  return (
    <Card className="shadow-medium border border-border-light rounded-xl bg-gradient-to-r from-white to-blue-50">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-6">
          <Avatar 
            size={80} 
            icon={<UserOutlined />}
            className="bg-gradient-to-br from-accent-blue to-blue-600"
          />
          <div>
            <Title level={2} className="m-0 text-text-primary">
              {getGreeting()}, {user?.name || 'Developer'}! 👋
            </Title>
            <Text className="text-text-secondary text-lg">
              {getMotivationalMessage()}
            </Text>
            <div className="flex items-center space-x-4 mt-3">
              <Tag color="blue" className="flex items-center space-x-1">
                <CalendarOutlined />
                <span>{new Date().toLocaleDateString('en-US', { 
                  weekday: 'long', 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}</span>
              </Tag>
              {user?.role === 'admin' && (
                <Tag color="gold" className="flex items-center space-x-1">
                  <TrophyOutlined />
                  <span>Administrator</span>
                </Tag>
              )}
            </div>
          </div>
        </div>
        <div className="text-right">
          <Button 
            type="primary" 
            icon={<RocketOutlined />}
            className="bg-accent-blue hover:bg-accent-blue/90"
          >
            Quick Actions
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default WelcomeCard;
